import { OptionsObject, SnackbarMessage, useSnackbar } from "notistack";
import { useHistory } from "react-router";
import Routes from "./Routes";

let history: any = null;
export const getHistory = () => {
  return history;
};

export const tryHistoryPush = (arg: any) => {
  if (history) history.push(arg);
};


let enqSnackbar: any = null;


export const tryEnqueueSnackbar = (message: SnackbarMessage, options?: OptionsObject) => {
  if (enqSnackbar) enqSnackbar(message, options)
};

export default function Main() {
  history = useHistory();
  enqSnackbar = useSnackbar().enqueueSnackbar
  return (
    <>
      <Routes />
    </>
  );
}
